/**
 * Product Compare Read More Toggle
 * 
 * Funcionalidade para expandir/colapsar descrições dos produtos
 * na tabela de comparação com botões "Leia mais" e "Leia menos"
 */

document.addEventListener('DOMContentLoaded', () => {
  // Aguardar o modal ser carregado
  setTimeout(() => {
    initReadMoreToggle();
    observeReadMoreToggles();
  }, 500);
});

// Inicializar funcionalidade de "Leia mais/Leia menos"
function initReadMoreToggle() {
  const toggleButtons = document.querySelectorAll('.compare-description-toggle');
  
  toggleButtons.forEach(button => {
    // Remover listeners existentes para evitar duplicação
    button.removeEventListener('click', handleReadMoreToggle);
    button.addEventListener('click', handleReadMoreToggle);
  });
}

// Handler para o clique no botão de toggle
function handleReadMoreToggle() {
  const descriptionContainer = this.closest('.compare-description');
  const content = descriptionContainer.querySelector('.compare-description-content');
  const gradient = descriptionContainer.querySelector('.compare-description-gradient');
  const readMore = this.querySelector('.compare-description-read-more');
  const readLess = this.querySelector('.compare-description-read-less');
  
  // Verificar se está expandido
  const isExpanded = descriptionContainer.classList.contains('expanded');
  
  if (isExpanded) {
    // Colapsar
    descriptionContainer.classList.remove('expanded');
    if (gradient) gradient.style.display = 'block';
    if (readMore) readMore.style.display = 'inline';
    if (readLess) readLess.style.display = 'none';
  } else {
    // Expandir
    descriptionContainer.classList.add('expanded');
    if (gradient) gradient.style.display = 'none';
    if (readMore) readMore.style.display = 'none';
    if (readLess) readLess.style.display = 'inline';
  }
}

// Observar mudanças no DOM para reinicializar os toggles quando necessário
function observeReadMoreToggles() {
  const compareArea = document.querySelector('.js-compare-area');
  
  if (compareArea) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Verificar se foram adicionados novos botões de toggle
          const newToggles = mutation.target.querySelectorAll('.compare-description-toggle');
          if (newToggles.length > 0) {
            // Reinicializar os toggles para novos elementos
            setTimeout(() => {
              initReadMoreToggle();
            }, 100);
          }
        }
      });
    });
    
    observer.observe(compareArea, { childList: true, subtree: true });
  }
}

// Função para reinicializar manualmente se necessário
window.reinitReadMoreToggles = function() {
  initReadMoreToggle();
};
